export default "__VITE_ASSET__2fe95777__"